function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NamibiaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2297",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2297)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#009933"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2297",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_2297)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21L24 3H0Z",
        fill: "#3195F9"
      }), /*#__PURE__*/_jsx("path", {
        d: "M-0.540419 23.1994L-0.275141 23.68L0.178677 23.3711L26.3026 5.58908L26.6536 5.35013L26.4746 4.96503L24.7183 1.18564L24.4726 0.657097L23.9876 0.980261L-2.52919 18.6476L-2.91196 18.9027L-2.6897 19.3053L-0.540419 23.1994Z",
        fill: "#E31D1C",
        stroke: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.67227 9.93354L3.7017 11.1444L3.4666 9.61048L2.02062 10.1739L2.58399 8.72787L1.05005 8.49277L2.26093 7.5222L1.05005 6.55163L2.58399 6.31653L2.02062 4.87055L3.4666 5.43392L3.7017 3.89998L4.67227 5.11086L5.64284 3.89998L5.87794 5.43392L7.32392 4.87055L6.76055 6.31653L8.29449 6.55163L7.08361 7.5222L8.29449 8.49277L6.76055 8.72787L7.32392 10.1739L5.87794 9.61048L5.64284 11.1444L4.67227 9.93354ZM4.67227 9.3972C5.7078 9.3972 6.54727 8.55773 6.54727 7.5222C6.54727 6.48667 5.7078 5.6472 4.67227 5.6472C3.63674 5.6472 2.79727 6.48667 2.79727 7.5222C2.79727 8.55773 3.63674 9.3972 4.67227 9.3972ZM6.17227 7.5222C6.17227 8.35063 5.5007 9.0222 4.67227 9.0222C3.84384 9.0222 3.17227 8.35063 3.17227 7.5222C3.17227 6.69377 3.84384 6.0222 4.67227 6.0222C5.5007 6.0222 6.17227 6.69377 6.17227 7.5222Z",
        fill: "#FECA00"
      })]
    })]
  })]
}));
//# sourceMappingURL=Namibia.js.map